export const contact = {
  email: "info@fortresssafeltd.com",
  phones: ["+254 755 555 595", "+971 561 213 570"],
  hours: "Mon-Sat, 9AM-6PM",
  poBox: "P.O. Box 43963-00100, Jomo Kenyatta International Airport",
  location: "Jomo Kenyatta International Airport, Nairobi",
  branch: "Jomo Kenyatta International Airport, Nairobi",
  map: {
    label: "Fortress Safe at JKIA",
    address: "Jomo Kenyatta International Airport, Embakasi, Nairobi, Kenya",
    coordinates: "1.31924° S, 36.92780° E",
    embedSrc:
      "https://www.openstreetmap.org/export/embed.html?bbox=36.9128%2C-1.3292%2C36.9428%2C-1.3092&layer=mapnik&marker=-1.31924%2C36.92780",
    directionsUrl: "https://www.google.com/maps/search/?api=1&query=-1.31924,36.92780",
  },
  whatsapp: "https://wa.me/+254755555595",
};
